<template>
	<div>
		<v-data-table
			hide-default-footer
			:items="items"
			item-key="id"
			:headers="colunas"
			:items-per-page="paginacaoInterna.rowsPerPage"
			:page="paginacaoInterna.page"
		>
			<template #item.icone="{ item }">
				<icone-tooltip
					v-if="item.importado"
					texto="Importado"
					tamanho="16px"
					icone="mdi-application-import"
					cor="grey"
				></icone-tooltip>
			</template>
			<template #item.itemDescricao="{ item }">
				<texto-tooltip :texto="item.itemDescricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
			</template>
			<template #item.saldoItemAta="{ item }">
				<span>{{ item.saldoItemAta | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #item.saldoSolicitado="{ item }">
				<span>{{ item.saldoSolicitado | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #item.saldoUtilizado="{ item }">
				<span>{{ item.saldoUtilizado | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #item.saldoEmProcessamento="{ item }">
				<span>{{ item.saldoEmProcessamento | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #item.saldoOrgao="{ item }">
				<span>{{ item.saldoOrgao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
		</v-data-table>
		<paginacao-tabela
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@paginar="$emit('paginar')"
			:show-rows-per-page="false"
			@resetar-page="resetarPaginaListagem"
		></paginacao-tabela>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabela from '@/views/mixins/tabela'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import rpCurrencyFilter from '@/views/filters/rp-currency-filter'
import IconeTooltip from '@/views/components/IconeTooltip.vue'

export default {
	name: 'ata-controle-saldos-orgao-listagem',
	components: { IconeTooltip, PaginacaoTabela, TextoTooltip },
	mixins: [tabela],
	props: {
		items: {
			type: Array,
			required: true,
		},
	},
	emits: ['paginar'],
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('', 'icone', '1%'),
				new TabelaColunaUtils('Tipo', 'tipo', '5%'),
				new TabelaColunaUtils('Seq.', 'sequencia', '5%'),
				new TabelaColunaUtils('Descrição', 'itemDescricao', '30%'),
				new TabelaColunaUtils('Unid. Aquis.', 'unidadeAquisicao', '8%'),
				new TabelaColunaUtils('Saldo Ata', 'saldoItemAta', '8%'),
				new TabelaColunaUtils('Solicitado', 'saldoSolicitado', '8%'),
				new TabelaColunaUtils('Utilizado', 'saldoUtilizado', '8%'),
				new TabelaColunaUtils('Em Processamento', 'saldoEmProcessamento', '8%'),
				new TabelaColunaUtils('Saldo Órgão', 'saldoOrgao', '8%'),
			],
			paginacaoInterna: this.paginacao,
			textoTamanhoMaximo: 100,
		}
	},
	computed: {
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	methods: {
		rpCurrencyFilter,
		resetarPaginaListagem() {
			this.paginacaoInterna.page = 1
		},
	},
}
</script>
